import { defaultFilterOptions } from '../../components/Shared/Filter'
import { translate } from '../../cls/TranslationContext'

const tourInfo = {
	name: {
		title: translate('single.item-name.label'),
		description: translate('single.item-name.description'),
		target: () => document.getElementById('target-info-name')
	},
	modified: {
		title: translate('single.last-modified'),
		description: translate('single.last-updated-description'),
		target: () => document.getElementById('target-info-modified')
	}
}

const tourForm = {
	section: {
		title: translate('single.form.section'),
		description: translate('single.section.required-fields'),
		target: () => document.getElementById('target-form')
	},
	name: {
		title: translate('__field%single.name'),
		description: translate('single.form.name-desc'),
		target: () => document.getElementById('target-form-name')
	},
	category_id: {
		title: translate('__field%_category.single'),
		description: translate('single.form.category-desc'),
		target: () => document.getElementById('target-form-category_id')
	},
	user_id: {
		title: translate('__field%_user.single'),
		description: translate('single.assign-responsible'),
		target: () => document.getElementById('target-form-user_id')
	},
	platformIds: {
		title: translate('__field%_platform.single'),
		description: translate('single.form.choose-platforms'),
		target: () => document.getElementById('target-form-platformIds')
	},
	progress: {
		title: translate('__field%single.progress'),
		description: translate('single.form.track-progress'),
		target: () => document.getElementById('target-form-progress')
	}
}

const tourFeatures = {
	section: {
		title: translate('single.feature.section-title'),
		description: translate('single.section.features'),
		target: () => document.getElementById('target-features')
	},
	recurrence: {
		title: translate('single.feature.recurrence'),
		description: translate('single.feature.recurrence-desc'),
		target: () => document.getElementById('target-features-recurrence')
	},
	subtasks: {
		title: translate('single.feature.subtask-title'),
		description: translate('single.feature.subtask-desc'),
		target: () => document.getElementById('target-features-subtasks')
	},
	comments: {
		title: translate('__feature%_comment.multiple'),
		description: translate('_comment.description'),
		target: () => document.getElementById('target-features-comments')
	}
}

const tourRecurrence = {
	section: {
		title: translate('single.recurrence.section'),
		description: translate('single.section.recurrence'),
		target: () => document.getElementById('target-recurrenceformitems')
	},
	recurrencenext: {
		title: translate('single.recurrence.next'),
		description: translate('single.recurrence.next-desc'),
		target: () =>
			document.getElementById('target-recurrenceformitems-recurrencenext')
	},
	recurrencetype: {
		title: translate('__type%_recurrence'),
		description: translate('single.recurrence.type-desc'),
		target: () =>
			document.getElementById('target-recurrenceformitems-recurrencetype')
	},
	recurrencestartend: {
		title: translate('single.recurrence.start-end'),
		description: translate('single.recurrence.start-end-desc'),
		target: () =>
			document.getElementById(
				'target-recurrenceformitems-recurrencestartend'
			)
	},
	recurrencetimes: {
		title: translate('single.recurrence.times'),
		description: translate('single.recurrence.times-desc'),
		target: () =>
			document.getElementById(
				'target-recurrenceformitems-recurrencetimes'
			)
	},
	recurrencedaysofweek: {
		title: translate('single.recurrence.days-of-week'),
		description: translate('single.recurrence.days-of-week-desc'),
		target: () =>
			document.getElementById(
				'target-recurrenceformitems-recurrencedaysofweek'
			)
	},
	recurrencedayofmonth: {
		title: translate('single.recurrence.day-of-month'),
		description: translate('single.recurrence.day-of-month-desc'),
		target: () =>
			document.getElementById(
				'target-recurrenceformitems-recurrencedayofmonth'
			)
	},
	recurrencemonths: {
		title: translate('single.recurrence.months'),
		description: translate('single.recurrence.months-desc'),
		target: () =>
			document.getElementById(
				'target-recurrenceformitems-recurrencemonths'
			)
	}
}

const _filterOptionsLabels = defaultFilterOptions
	.filter((option) => option.value)
	.map((option) => option.label)

// console.log('_filterOptionsLabels', defaultFilterOptions)
const tourFilter = {
	section: {
		title: translate('single.section.filter.label'),
		description: translate('single.section.filter.description'),
		target: () => document.getElementById('target-filter')
	},
	name: {
		title: translate('single.filter.name'),
		description: translate('single.filter.name-desc'),
		target: () => document.getElementById('target-info-name')
	},
	search: {
		title: translate('single.filter.search'),
		description: translate('single.filter.search-desc'),
		target: () => document.getElementById('target-filter-search')
	},
	progress: {
		title: 'Status',
		description: `Filter items based on their progress status. (Example: ${_filterOptionsLabels.join(
			', '
		)})`,
		target: () => document.getElementById('target-filter-progress')
	},
	category: {
		title: translate('single.filter.category'),
		description: translate('single.filter.category-desc'),
		target: () => document.getElementById('target-filter-category')
	},
	delete: {
		title: translate('single.filter.deleted'),
		description: translate('single.filter.deleted-desc'),
		target: () => document.getElementById('target-filter-deleted')
	},
	new: {
		title: translate('single.filter.new'),
		description: translate('single.filter.new-desc'),
		target: () => document.getElementById('target-filter-addnew')
	},
	toggleBtn: {
		title: translate('single.filter.toggle'),
		description: translate('single.filter.toggle-desc'),
		target: () => document.getElementById('target-filter-toggle-btn')
	},
	ByUser: {
		title: translate('__by%_user.single'),
		description: translate('single.for-user.label'),
		target: () => document.getElementById('target-filter-user')
	},
	orderBy: {
		title: translate('single.order-by'),
		description: translate('single.filter.order-by-desc'),
		target: () => document.getElementById('target-filter-order-by')
	},
	ForUser: {
		title: translate('single.filter.for-user'),
		description: translate('single.filter.for-user-desc'),
		target: () => document.getElementById('target-filter-for-user')
	},
	priority: {
		title: translate('single.filter.priority-desc'),
		description: translate('single.filter.priority-desc'),
		target: () => document.getElementById('target-filter-priority')
	},
	currency: {
		title: translate('single.filter.currency'),
		description: translate('single.filter.currency-desc'),
		target: () => document.getElementById('target-filter-currency')
	}
}

///////////////////////// Here //////////////////////////

const tourRequestLst = {
	section: {
		title: translate('_overview%_request'),
		description: translate(
			'__manage-from-this-list%_sprint.definite.multiple'
		),
		target: () => document.getElementById('items-lst')
	},
	request: {
		title: translate('_request'),
		description: translate('single.sprint-title-progress-xxxx'),
		target: () => document.getElementById('target-request')
	},
	product: {
		title: translate('single.request.product'),
		description: translate('single.sprint-title-progress-xxxx'),
		target: () => document.getElementById('target-product-owner')
	},
	requestFor: {
		title: translate('single.request.for2'),
		description: translate('single.sprint-title-progress-xxxx'),
		target: () => document.getElementById('target-request-for')
	},
	actions: {
		title: translate('single.actions-column.label'),
		description: translate('single.actions-column.description'),
		target: () => document.getElementById('target-actions')
	}
}

const tourMonthlyReportLst = {
	section: {
		title: translate('__lst.title%_sprint'),
		description: translate(
			'__manage-from-this-list%_sprint.definite.multiple'
		),
		target: () => document.getElementById('items-lst')
	},
	sprint: {
		title: translate('single.month'),
		description: translate('single.sprint-title-progress-xxxx'),
		target: () => document.getElementById('target-monthly-report')
	},
	info: {
		title: translate('_hour.multiple'),
		description: translate('single.sprint-see-details-xxxx'),
		target: () => document.getElementById('target-hours')
	},
	users: {
		title: translate('_user.multiple'),
		description: translate('single.recurrence-settings-xxxx'),
		target: () => document.getElementById('target-user')
	},
	actions: {
		title: translate('single.actions-column.label'),
		description: translate('single.actions-column.description'),
		target: () => document.getElementById('target-actions')
	}
}

const tourSprintLst = {
	section: {
		title: translate('__lst.title%_sprint'),
		description: translate(
			'__manage-from-this-list%_sprint.definite.multiple'
		),
		target: () => document.getElementById('items-lst')
	},
	sprint: {
		title: translate('_overview%_sprint'),
		description: translate('single.sprint-title-progress-xxxx'),
		target: () => document.getElementById('target-sprint')
	},
	info: {
		title: translate('single.sprint-information'),
		description: translate('single.sprint-see-details-xxxx'),
		target: () => document.getElementById('target-info')
	},
	recurrence: {
		title: translate('_recurrence'),
		description: translate('_recurrence'),
		target: () => document.getElementById('target-recurrence')
	},
	actions: {
		title: translate('single.actions-column.label'),
		description: translate('single.actions-column.description'),
		target: () => document.getElementById('target-actions')
	},
	itmPriority: {
		title: translate('__priority%_sprint'),
		description: translate('single.priority-indicator-description'),
		target: () => document.getElementById('target-itm-priority')
	},
	itmProgress: {
		title: translate('__progress%_sprint'),
		description: translate('single.progress-indicator-description'),
		target: () => document.getElementById('target-itm-progress')
	},
	itmLink: {
		title: translate('__view%_sprint'),
		description: translate('single.click-title-more-details-xxxx'),
		target: () => document.getElementById('target-itm-link')
	},
	itmUser: {
		title: translate('single.assigned-user-client-xxx'),
		description: translate('single.assigned-to-xxxx'),
		target: () => document.getElementById('target-itm-user')
	},
	itmCategory: {
		title: translate('single.category'),
		description: translate(
			'__view-x-assigned-to-x%_category.definite.single%_sprint.possessive.single'
		),
		target: () => document.getElementById('target-itm-category')
	},
	itmRecurrence: {
		title: translate('__status%_recurrence'),
		description: translate('single.recurrence-indicator-description'),
		target: () => document.getElementById('target-itm-recurrence')
	},
	itmInfo: {
		title: translate('single.additional-information'),
		description: translate(
			'single.sprint-view-additional-information-xxxx'
		),
		target: () => document.getElementById('target-itm-info')
	},
	itmActions: {
		title: translate('_action.multiple'),
		description: translate('single.perform-actions-like-xxxx'),
		target: () => document.getElementById('target-itm-actions')
	}
}

const tourSecured = {
	searchName: {
		title: translate('__field%single.search.label'),
		description: translate('single.secured.key-search'),
		target: () => document.getElementById('target-search-name')
	},
	searchKey: {
		title: translate('__field%single.key'),
		description: translate('single.secured.key-associated'),
		target: () => document.getElementById('target-search-key')
	},
	searchBtn: {
		title: translate('single.search-button'),
		description: translate('single.search-button-click'),
		target: () => document.getElementById('target-search-btn')
	},
	addNew: {
		title: translate('single.secured.add-new'),
		description: translate('single.secured.add-new-click'),
		target: () => document.getElementById('target-secured-add-new')
	}
}

const tourBilling = {
	options: {
		title: translate('single.subscription.plans'),
		target: () => document.getElementById('target-button-details')
	},

	yourSubscriptions: {
		title: translate('single.subscription.my-subscriptions'),
		target: () => document.getElementById('target-button-preferences')
	}
}

/*
* FIX THIS:
 	Naming the id's is an important task. We need to make sure we have a consistent naming convention for the id's.
    - Example i gave you for dashboard link: menu-dashboard. Considering this is a menu item, we will use the convention: 'menu-' + 'name'.
	- When we have a menu with children, we will respect the parent-child relationship and name the children like this: 'menu-' + 'parent-name' + '-' + 'child-name'. Example: 'menu-management-profile'.

	=> Rename all id's in this tourDashboard object to follow the convention. And also, this is not a tour for dashboard, this is an app tour. So we need to rename this object to tourApp that will contain tourSidebar, tourHeader, tourFooter, etc. And we will have another object called tourDashboard that will contain the id's for the dashboard page specifically.

	!! Were you have id's in this config/index.js page that starts with 'target-' those are id's that are specifically used for tour inside pages, were an id was added with the sole purpose of tour.
*/
const tourApp = {
	menu: {
		title: translate('single.dashbord'),
		description: translate('single.menu-description'),
		target: () => document.getElementById('menu-dashboard')
	},
	notifications: {
		title: translate('_notification.multiple'),
		description: translate('single.section.notifications'),
		target: () => document.getElementById('menu-notifications')
	},
	management: {
		title: translate('_management'),
		description: translate('single.section.management'),
		target: () => document.getElementById('menu-management')
	},
	managementProfile: {
		title: translate('single.profile-page.title'),
		description: translate('single.section.profile-description'),
		target: () => document.getElementById('menu-management-profile')
	},
	managementUserList: {
		title: translate('__lst.title%_user'),
		description: translate('single.user-list-view.description'),
		target: () => document.getElementById('menu-management-user-list')
	},
	managementBudgetList: {
		title: translate('_budget'),
		description: translate('single.budget-list-description'),
		target: () => document.getElementById('menu-management-budget')
	},
	managementRecruitments: {
		title: translate('_recruitment.multiple'),
		description: translate('single.recruitments-description'),
		target: () => document.getElementById('menu-management-recruitments')
	},
	menuBilling: {
		title: translate('single.billing'),
		description: translate('single.billing-description'),
		target: () => document.getElementById('menu-billing')
	},
	menuBillingSubscription: {
		title: translate('_subscription'),
		description: translate('single.billing-subscription-description'),
		target: () => document.getElementById('menu-billing-subscriptions')
	},
	menuFeatures: {
		title: translate('_feature'),
		description: translate('single.features-description'),
		target: () => document.getElementById('menu-features')
	},
	menuFeaturesSprints: {
		title: translate('_sprint.multiple'),
		description: translate('single.sprints-feature-description'),
		target: () => document.getElementById('menu-features-sprints')
	},
	menuFeaturesMonthlyReports: {
		title: translate('_monthly-report.multiple'),
		description: translate('single.monthly-reports-feature-description'),
		target: () => document.getElementById('menu-features-monthly-reports')
	},
	menuFeaturesMonthlyRequests: {
		title: translate('_request.multiple'),
		description: translate('single.monthly-requests-feature-description'),
		target: () => document.getElementById('menu-features-monthly-requests')
	},
	menuFeaturesMonthlySecured: {
		title: translate('single.secured.label'),
		description: translate('single.secured-feature-description'),
		target: () => document.getElementById('menu-features-monthly-secured')
	},
	menuInfo: {
		title: translate('single.info'),
		description: translate('single.info-menu-description'),
		target: () => document.getElementById('menu-info')
	},
	menuInfoServices: {
		title: translate('single.services'),
		description: translate('single.services-info-description'),
		target: () => document.getElementById('menu-info-services')
	},
	menuInfoWordpress: {
		title: translate('single.wordpress'),
		description: translate('single.wordpress-info-description'),
		target: () => document.getElementById('menu-info-wordpress')
	},
	menuInfoProgrammingTech: {
		title: translate('single.programming-tech'),
		description: translate('single.programming-info-description'),
		target: () => document.getElementById('menu-info-programming-tech')
	},
	menuInfoDigitalMarketing: {
		title: translate('single.digital-marketing'),
		description: translate('single.marketing-info-description'),
		target: () => document.getElementById('menu-info-digital-marketing')
	},
	menuInfoBusiness: {
		title: translate('single.business'),
		description: translate('single.business-info-description'),
		target: () => document.getElementById('menu-info-business')
	},
	menuInfoGraphicDesign: {
		title: translate('single.graphic-design'),
		description: translate('single.graphic-design-info-description'),
		target: () => document.getElementById('menu-info-graphics-design')
	},
	menuInfoWritingTranslation: {
		title: translate('single.writing-translation'),
		description: translate('single.writing-translation-info-description'),
		target: () => document.getElementById('menu-info-writing-translation')
	},
	menuDocumentation: {
		title: translate('_documentation'),
		description: translate('single.documentation-menu-description'),
		target: () => document.getElementById('menu-documentation')
	},
	menuDocumentationMain: {
		title: translate('_documentation.other'),
		description: translate('single.documentation-main-menu-description'),
		target: () => document.getElementById('menu-documentation-main')
	},
	menuPages: {
		title: 'Pages',
		description: translate('single.pages-menu-description'),
		target: () => document.getElementById('menu-pages')
	}
}

const tourDashboard = {
	intro: {
		title: translate('single.logged-in-user-name'),
		target: () => document.getElementById('target-dashboard-title')
	},
	languageSettings: {
		title: translate('__settings%single.language.label'),
		description: translate('single.language.description'),
		target: () =>
			document.getElementById('target-language-selector-dashboard')
	},
	getStarted: {
		title: translate('single.get-started.label'),
		description: translate('single.get-started.recommended-cards'),
		target: () => document.getElementById('target-get-started')
	},
	dashboardTable: {
		title: translate('single.user-info'),
		description: translate('single.dashboard-table-description'),
		target: () => document.getElementById('target-table-dashboard')
	}
}

const tourProfile = {
	profile: {
		title: translate('single.profile-page.title'),
		description: translate('single.profile-page.description'),
		target: () => document.getElementById('target-user-edit-text')
	},
	buttonDetails: {
		title: translate('single.details'),
		description: translate('single.general-information-tab'),
		target: () => document.getElementById('target-button-details')
	},
	buttonPermissions: {
		title: translate('_permision.multiple'),
		description: translate('_notification.tab-notification-settings'),
		target: () => document.getElementById('target-button-permissions')
	},
	buttonPlatforms: {
		title: translate('_platform.multiple'),
		description: translate('_platform.sprints-relation'),
		target: () => document.getElementById('target-button-platforms')
	},
	buttonPreferences: {
		title: translate('single.preferences'),
		description: translate('single.section.preferences'),
		target: () => document.getElementById('target-button-preferences')
	},
	buttonAdmin: {
		title: translate('single.admin'),
		description: translate('single.section.admin.description'),
		target: () => document.getElementById('target-button-admin')
	}
}

const tourUserDetails = {
	generalSettings: {
		title: translate('single.general-settings'),
		description: translate('single.section.required-user-identification'),
		target: () => document.getElementById('target-section-general')
	},
	userBusinessDetails: {
		title: translate('single.business-details.label'),
		description: translate('single.business-details.description'),
		target: () => document.getElementById('target-section-business')
	},
	userContactDetails: {
		title: translate('single.contract.details.title'),
		description: translate('single.section.contract'),
		target: () => document.getElementById('target-section-contact')
	}
}

const tourUserPlatforms = {
	platforms: {
		title: translate('_platform.multiple'),
		description: translate('_platform.sprints-relation'),
		target: () => document.getElementById('target-section-platforms')
	}
}

const tourUserPreferences = {
	sprintFilters: {
		title: translate('_sprint.filter.preferences'),
		description: translate('single.sprint-filters-description'),
		target: () => document.getElementById('target-preferences-tab')
	}
}

const tourUserPermissions = {
	manageNotifications: {
		title: translate('__manage%_notification.multiple'),
		description: translate('_notification.control-permissions'),
		target: () => document.getElementById('target-section-notifications')
	}
}

const tourUserAdminSection = {
	manageRoles: {
		title: translate('__manage%_role.multiple'),
		description: translate('single.section.roles'),
		target: () => document.getElementById('target-section-roles')
	},
	managePermissions: {
		title: translate('__manage%_permision.multiple'),
		description: translate('single.manage-permissions-description'),
		target: () => document.getElementById('target-section-permissions')
	},

	manageCategories: {
		title: translate('__manage%_category.multiple'),
		description: translate('single.manage-categories-description'),
		target: () => document.getElementById('target-section-categories')
	},
	manageResources: {
		title: translate('__manage%_resource.multiple'),
		description: translate('single.manage-resources-description'),
		target: () => document.getElementById('target-section-resources')
	}
}

const tour = {
	form: tourForm,
	features: tourFeatures,
	recurrence: tourRecurrence,
	info: tourInfo,
	sprintLst: tourSprintLst,
	monthlyReportLst: tourMonthlyReportLst,
	requestLst: tourRequestLst,
	securedList: tourSecured,
	billingList: tourBilling,
	appList: tourApp,
	userProfile: tourProfile,
	userDetails: tourUserDetails,
	userPlatforms: tourUserPlatforms,
	userPreferences: tourUserPreferences,
	userPermissions: tourUserPermissions,
	userAdminSection: tourUserAdminSection,
	dashboard: tourDashboard,
	filter: tourFilter,
	notificationLst: null
}

/**
 * listTarget is string, we need to target the object in this file
 *keys example: ['recurrence', 'subtasks', 'comments']
 * hiddenKeys example: ['recurrence', 'subtasks', 'comments'] - Objective is to hide the keys from the object
 */
const getTourArrayByKeys = (target, keys, hiddenKeys) => {
	// check if target is valid
	if (!tour[target]) {
		return []
	}
	if (keys.length === 1 && keys[0] === 'all') {
		// return all keys value as array
		return Object.keys(tour[target]).map((key) => {
			// tour[target][key]
			if (hiddenKeys && hiddenKeys.includes(key)) {
				return
			}
			const obj = tour[target][key]
			if (!obj) {
				return
			}
			return {
				title: obj.title,
				description: obj.description,
				target: obj.target
			}
		})
	}

	return keys
		.map((key) => {
			if (hiddenKeys && hiddenKeys.includes(key)) {
				return
			}
			const obj = tour[target][key]
			if (!obj) {
				return
			}
			return {
				title: obj.title,
				description: obj.description,
				target: obj.target
			}
		})
		.filter(Boolean)
}

export { tour, getTourArrayByKeys }
